import { useEffect, useState } from 'react';

const useScroll = (delay = 15) => {
  const [data, setData] = useState({ scrollY: window.scrollY });

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const scrollListener = () => {
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        setData((prev) => ({ ...prev, scrollY: window.scrollY }));
      }, delay);
    };

    window.addEventListener('scroll', scrollListener);

    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, [data]);

  return data;
};

export default useScroll;
